const state = {
  shouldRefreshUser: true,
};

// getters
const getters = {
  shouldRefreshUser: (state) => (state.shouldRefreshUser),
};

// mutations
const mutations = {
  updateShouldRefreshUser(state, shouldRefreshUser) {
    state.shouldRefreshUser = shouldRefreshUser;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
